import { OVERRIDE_WALLET_SESSION_KEY } from "@/constants/local-storage-keys";

interface Env {
  isProduction: boolean;
}

// Runs before the address bar is sanitized, so the key never reaches analytics or history.
export function captureOverrideWallet(search: string, { isProduction }: Env): void {
  if (isProduction) return;
  const value = new URLSearchParams(search).get("override_wallet");
  if (!value) return;
  try {
    sessionStorage.setItem(OVERRIDE_WALLET_SESSION_KEY, value);
  } catch {
    // storage unavailable
  }
}

export function readOverrideWallet({ isProduction }: Env): string | null {
  if (isProduction || typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(OVERRIDE_WALLET_SESSION_KEY);
  } catch {
    return null;
  }
}
